// src/pages/AdminLogin.jsx
import React, { useState } from "react";
import {
  Box,
  Paper,
  Stack,
  TextField,
  Button,
  Typography,
  Alert,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { api, setToken } from "../api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const isEmailValid = (v) => /\S+@\S+\.\S+/.test(v);

  async function handleLogin(e) {
    e.preventDefault();
    setErr("");

    if (!isEmailValid(email)) {
      setErr("Please enter a valid email address.");
      return;
    }
    if (!password) {
      setErr("Password is required.");
      return;
    }

    try {
      setLoading(true);
      const { token } = await api("/api/auth/login", {
        method: "POST",
        body: { email, password },
      });
      if (!token) throw new Error("No token returned");
      setToken(token);
      // Use whichever routing you have:
      navigate("/admin"); // or: window.location.href = "/admin";
    } catch (e2) {
      setErr("Invalid credentials");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 3, sm: 4 },
          width: "100%",
          maxWidth: 420,
          borderRadius: 3,
        }}
      >
        <form onSubmit={handleLogin} noValidate>
          <Stack spacing={2.5}>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Admin Login
            </Typography>

            {err ? <Alert severity="error">{err}</Alert> : null}

            <TextField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              required
              autoComplete="email"
              autoFocus
              disabled={loading}
            />

            <TextField
              label="Password"
              type={showPw ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              required
              autoComplete="current-password"
              disabled={loading}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={showPw ? "Hide password" : "Show password"}
                      onClick={() => setShowPw((s) => !s)}
                      edge="end"
                      disabled={loading}
                    >
                      {showPw ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="contained"
              type="submit"
              disabled={loading}
              size="large"
            >
              {loading ? "Logging in..." : "Login"}
            </Button>
          </Stack>
        </form>
      </Paper>
    </Box>
  );
}
